const data={
    "SCROLL_ITEM_EMAIL_LIST": "fa-envelope",
    "SCROLL_ITEM_CONTACT_LIST": "fa-phone",
    "SCROLL_ITEM_BASIC_INFO": "fa-info-circle",
    "SCROLL_ITEM_EMPLOYEES": "fa-id-card-o",
    "SCROLL_ITEM_SITE_LIST": "fa-list-alt",
  };

  function match(prop){
  	return data[prop];
  }

export default{
	matcher:match
}



// WEBPACK FOOTER //
// ./src/common/filters/icon-translate.js